/**
 * Is the candidate an array?
 *
 * @param {Object} candidate
 * @return {Boolean}
 */

export default function(candidate){
	return Object.prototype.toString.call( candidate ) === '[object Array]'; 
}